<template lang="pug">
.insights-dashboard.widget-wrapper
  .widget-wrapper-columns.widget-panels-dashboard
    InsightsWorkTimeClassificationWidget.widget-panel(
      :chart-size="80"
      :chart-radius="34"
    )
    InsightsActivityWidget.widget-panel
    InsightsProficiencyRankingWidget(
      label="Top core work members"
      :ranking="proficiencyRankingTop"
    )
    InsightsProficiencyRankingWidget(
      label="Low core work members"
      :ranking="proficiencyRankingBottom"
    )
  .widget-footer.py-0
    a(:href="insightsUrl")
      | View all
      i.hi.hi-right.hi-10.ml-5
</template>

<script>
import { mapGetters } from 'vuex';

import InsightsActivityWidget from './InsightsActivityWidget.vue';
import InsightsWorkTimeClassificationWidget from './InsightsWorkTimeClassificationWidget.vue';
import InsightsProficiencyRankingWidget from './InsightsProficiencyRankingWidget.vue';

export default {
  name: 'InsightsDashboardWidget',
  components: {
    InsightsActivityWidget,
    InsightsWorkTimeClassificationWidget,
    InsightsProficiencyRankingWidget,
  },
  computed: {
    ...mapGetters(['proficiencyRankingTop', 'proficiencyRankingBottom', 'insightsUrl']),
  },
};
</script>
